<script lang="ts" setup></script>

<template>
  <svg fill="none" height="28" viewBox="0 0 28 28" width="28" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_3386_105909)">
      <path
        d="M5.13353 6.61424V3.65868C5.13353 2.87482 5.44492 2.12306 5.99919 1.56879C6.55346 1.01451 7.30522 0.703125 8.08908 0.703125H24.3446C25.1285 0.703125 25.8803 1.01451 26.4345 1.56879C26.9888 2.12306 27.3002 2.87482 27.3002 3.65868V24.3476C27.3002 25.1314 26.9888 25.8832 26.4345 26.4375C25.8803 26.9917 25.1285 27.3031 24.3446 27.3031H8.08908C7.30522 27.3031 6.55346 26.9917 5.99919 26.4375C5.44492 25.8832 5.13353 25.1314 5.13353 24.3476V21.392H8.08908V24.3476H24.3446V3.65868H8.08908V6.61424H5.13353ZM13.2613 5.87535L11.1717 7.96493L15.7322 12.5253H0.700195V15.4809H15.7322L11.1717 20.0413L13.2613 22.1309L21.3891 14.0031L13.2613 5.87535Z"
        fill="#F40000"
      />
    </g>
    <defs>
      <clipPath id="clip0_3386_105909">
        <rect fill="white" height="28" width="28" />
      </clipPath>
    </defs>
  </svg>
</template>

<style lang="sass" scoped></style>
